export default __webpack_public_path__ + "static/conversation-ef27dd6f1f87090c28328aa12dfcbfd9.png";